// Central source of truth for business info. Update these values here
// and they propagate across every page, the footer, and SEO metadata.

export const SITE = {
  name: 'Parotta Express',
  tagline: 'Fresh food made from utmost care',
  cuisine: 'Authentic South Indian Cuisine',
  city: 'Coppell, TX',

  about: [
    'Parotta Express brings the authentic taste of South Indian parotta to Coppell with bold spices and traditional flavors.',
    'Our signature flaky parottas are served with rich curries, flavorful chicken dishes, and classic Indian sides prepared fresh every day.',
    'From street-style favorites to comforting meals, every dish is crafted to deliver a memorable Indian food experience.',
  ],

  phone: '(945) 910-3010',
  phoneHref: 'tel:+19459103010',
  email: 'home.made.delights.tx@gmail.com',
  emailHref: 'mailto:home.made.delights.tx@gmail.com',

  address: {
    line1: '820 S MacArthur Blvd, Ste 112',
    line2: 'Coppell, TX 75019',
    full: '820 S MacArthur Blvd, Ste 112, Coppell, TX 75019',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Parotta+Express+820+S+MacArthur+Blvd+112+Coppell+TX+75019',
  },

  // NOTE: Hours vary slightly across listing platforms. Confirm & adjust here.
  hours: [
    { day: 'Monday', time: '12:00 PM – 11:00 PM' },
    { day: 'Tuesday', time: '12:00 PM – 11:00 PM' },
    { day: 'Wednesday', time: '12:00 PM – 11:00 PM' },
    { day: 'Thursday', time: '12:00 PM – 11:00 PM' },
    { day: 'Friday', time: '12:00 PM – 12:00 AM' },
    { day: 'Saturday', time: '12:00 PM – 12:00 AM' },
    { day: 'Sunday', time: '12:00 PM – 11:00 PM' },
  ],

  // Third-party ordering / social. Replace with the restaurant's own links.
  order: {
    toast: 'https://www.toasttab.com/local/order/hmdparottaexpress',
    ubereats: 'https://www.ubereats.com/store/parotta-express-820-s-macarthur-blvd-112/yK3jtbr0XD6oR-cJq1zpZw',
    doordash: 'https://www.doordash.com/store/parotta-express-new-ownership-820-s-macarthur-blvd-112-coppell-34971177/',
    grubhub: 'https://www.grubhub.com/restaurant/parotta-express-820-s-macarthur-blvd--112-coppell/3120952',
  },
  social: {
    facebook: 'https://www.facebook.com/people/Parotta-Express/61561526191858/',
  },
} as const;

// The word marquee shown between sections.
export const MARQUEE = [
  'Flaky Ceylon Parottas',
  'Chettinad Curries',
  'Dindugal Mutton Biryani',
  'Crispy Dosas',
  'Kothu Parotta',
  'Karaikudi Spices',
  'Filter Coffee & Irani Chai',
  'Made Fresh Daily',
];
